import { hasAccessibleName } from "./has-accessible-name.js";
import { hasValue } from "../../name/predicate/has-value.js";
/**
 * @public
 */
export function hasNonEmptyAccessibleName(device) {
    return hasAccessibleName(device, hasValue((value) => value.trim().length > 0));
}
//# sourceMappingURL=has-non-empty-accessible-name.js.map